// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZbNF","rootNoMargin":"styles_rootNoMargin__2K1cn"};